import actions from './actions.js';
import mutations from './mutations.js';

// state
const state = () => ({
  // 未読数
  unreadCount: 0,
  // 未読事前問診のID
  unreadIds: [],
});

// getters
const getters = {
  unreadCount: (state) => state.unreadCount,
  unreadIds: (state) => state.unreadIds,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
